/* eslint-disable no-nested-ternary */
import { Box, Container, useMediaQuery, Grid, Typography, Stack } from '@mui/material';
import React, { useContext, useState, useEffect, useCallback, useRef } from 'react';
import { useApolloClient } from '@apollo/client';
import { useRouter } from 'next/router';
import getConfig from 'next/config';
import { useTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeftRounded';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRightRounded';
// eslint-disable-next-line import/no-unresolved
import { SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import SwiperCarousel from '../shared/SwiperCarousel';
import styles from './styles';
import EirOfferCard from '../eir-offer-card/EirOfferCard';
import EirInformation from '../eir-information/EirInformation';
import {
  // getStaticBroadband,
  // getRecommendedBroadband,
  addTariff,
  removeTariff,
  onload,
  getFilteredOfferData,
} from './Broadband.util';
import RootContext from '../../../util/root.context';
import { displayCart } from '../eir-cart/cart.util';
import useLocalStorage, { getLocalStorage } from '../../hooks/useLocalStorage';
import useMaxHeightCard from '../eir-offer-card/offer-cart.util';
import EirSingleOfferCard from '../eir-offer-card/EirSingleOfferCard';
import { addToCartAnalytics, removeFromCartAnalytics } from '../../../util/gtm';
import { formatAfterPrice } from '../../../util/Format.util';
import { useToggle } from '../../hooks/useToggle';
import ErrorModal from '../eir-error-modal/ErrorModal';
import getCarts from '../../integration/cart.api';
import { getCookie, setCookie } from '../../hooks/useCookie';
import ApiFailureModal from '../eir-error-modal/ApiFailureModal';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';
import LoginMain403 from '../eir-403-login/LoginMain403';

const { publicRuntimeConfig } = getConfig();

const BroadbandOfferCardContainer = ({
  cmsData,
  id,
  loading,
  setLoading,
  isNBIJourney,
  staticbbCard,
  isPrequaled,
  setShowTv,
  setShowAddon,
  setShowNext,
  setContractDuration,
  setOfferCode,
  offerCardButtonDisable,
  changeOffer = false,
  offerCardTextVisible = false,
  // setShowCrossSell,
  hideOfferCard,
  setHideCS,
  // myEirCOAdd,
  // setMyEirCOAdd,
  hideTV,
  eligibleForCO = true,
  hold,
}) => {
  const [broadbandData, setBroadbandData] = useState();
  const [offerSelected, setOfferSelected] = useState(null);
  const [leftArrowDisabled, setLeftArrowDisabled] = useState(true);
  const [RightArrowDisabled, setRightArrowDisabled] = useState(false);
  const openAPIFailureModal = useToggle(false);
  const [openError, setOpenError] = useState(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const [onLoadError, setOnLoadError] = useState(false);
  const errorModalMaxOccurence = 1;
  const errorBBModal = useToggle(false);
  const localStore = useLocalStorage();
  const router = useRouter();
  const graphql = useApolloClient();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const { state: rootState, dispatch } = useContext(RootContext);
  const nextStep = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/broadband/current-service`);
  };
  const handleOk = () => {
    openAPIFailureModal.disable();
  };

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
      errorBBModal.disable();
    } else {
      showModal.disable();
      errorBBModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  const theme = useTheme();
  const style = styles(theme);
  const swiperRef = useRef(null);
  const md = useMediaQuery(theme.breakpoints.down('md'));
  const xs = useMediaQuery(theme.breakpoints.down('sm'));
  const lg = useMediaQuery(theme.breakpoints.up('md'));

  const [showLoader, setShowLoader] = useState(' ');
  // const onLoadStaticBB = async () => {
  //   const result = await getStaticBroadband({ graphql });
  //   setBroadbandData(result?.sort((a, b) => a.sortOrder - b.sortOrder));
  // };
  // const onPrequalRecommendedBB = async () => {
  //   const result = await getRecommendedBroadband({ graphql });
  //   setBroadbandData(result);
  // };

  const broadband = cmsData?.EirInformation_Broadband_Title;

  const hasContent = broadband?.title?.trim() || broadband?.description?.trim();

  const broadbandOnload = async () => {
    if (getLocalStorage('PROSPECTUUID') && getCookie('cart_Type') !== 'CROSS_SELL') {
      const { getCart: cart } = await getCarts({
        graphql,
        variables: { reference: localStore.getLocalStorage('prospectuuid') },
      });
      dispatch({ type: 'SET_CART', payload: cart });
    }
    const { selectedBroadbandOffer, offers, cartData } = await onload({
      localStorage: localStore,
      graphql,
      dispatch,
      changeOffer, // to get CO tariffs
    });
    // set offers
    if (offers) {
      const offersData = offers?.map(offer => formatAfterPrice(offer));
      // setBroadbandData(offersData.sort((a, b) => a.price - b.price));

      const filteredOfferData = getFilteredOfferData(offersData);
      setBroadbandData(filteredOfferData);
      // if (getCookie('cart_Type') !== 'CHANGE_OFFER' && getCookie('cart_Type') !== 'CROSS_SELL')
      //   setLoading(false);
    } else {
      setOnLoadError(true);
      setLoading(true);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
    }
    // set selected offer and set Tv
    if (selectedBroadbandOffer) {
      setOfferSelected(selectedBroadbandOffer.code);
      // setShowCrossSell(false);
      setHideCS(true);
      const contractDuration = offers.filter(offer => offer.code === selectedBroadbandOffer.code)[0]
        .discountDuration;
      setContractDuration(contractDuration);

      dispatch({ type: 'SET_CART', payload: cartData });
      displayCart({
        dispatch,
        localStorage: localStore,
        graphql,
        cart: cartData,
        nextMethod: nextStep,
        disablenNextButton: false,
        showNextButton: false,
      });
      setShowAddon(true);
      if (getCookie('cart_Type') === 'CHANGE_OFFER' || getCookie('cart_type') === 'CROSS_SELL') {
        setShowAddon(false);
      }
      if (selectedBroadbandOffer.isTVOfferIncluded) {
        setShowTv(true);
        if (getCookie('cart_Type') && getCookie('cart_Type') === 'CHANGE_OFFER') {
          setShowNext(true);
        } else setShowNext(false);
      } else {
        setShowTv(false);
        setShowNext(true);
      }
    } else {
      setShowTv(false);
      setShowAddon(false);
      setShowNext(false);
      displayCart({
        dispatch,
        showCart: false,
      });
      if (!isPrequaled) {
        setOfferSelected(null);
      }
    }

    // setContractDuration(discountDuration);
  };

  /**
   * @name selectTariff - Function for adding selected tariff to the cart
   */
  const selectTariff = async (code, offerCode, discountDuration, selectedTariff) => {
    // setShowCrossSell(false);
    setHideCS(true);
    setShowLoader(code);
    setShowNext(false);
    // for showing relative skeletons
    if (getCookie('COMP_MAP')) {
      const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
      COMP_MAP.COSelected = true;
      COMP_MAP.CS = false;
      setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
    }

    let cartType = '';
    if (changeOffer) cartType = 'CHANGE_OFFER';
    try {
      const data = await addTariff(graphql, code, offerCode, rootState.cart, cartType);
      if (data) {
        addToCartAnalytics(data);
        dispatch({ type: 'SET_CART', payload: data });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: data,
          nextMethod: nextStep,
          disablenNextButton: false,
          showNextButton: false,
        });
        if (getCookie('cart_Type') !== 'CHANGE_OFFER' || !getCookie('cart_type') !== 'CROSS_SELL')
          setShowAddon(true);
        if (selectedTariff.isTVOfferIncluded) {
          setShowTv(true);
          if (cartType === 'CHANGE_OFFER') {
            if (hideTV) {
              // redirect
              router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
            }
            // else setShowNext(true);
          } else setShowNext(false);
        } else {
          setShowTv(false);
          setShowNext(true);
        }
        setContractDuration(discountDuration);
        setOfferCode(code);
        setOfferSelected(code);
        setShowLoader(' ');
        setErrorModalOccurence(0);
        errorBBModal.disable();
        setOnLoadError(false);
      } else {
        setShowAddon(false);
        setHideCS(false);
        setOnLoadError(false);
        if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
        if (!getCookie('token-missing') && !getCookie('found-403'))
          setErrorModalOccurence(errorModalOccurence + 1);
        if (!getCookie('found-403')) errorBBModal.enable();
        if (!getCookie('token-missing')) errorBBModal.enable();
        if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
        setShowLoader(' ');
      }
    } catch (err) {
      setHideCS(false);
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };
  /**
   * @name removeTariffs - Function for removing selected tariff from the cart
   */
  const removeTariffs = async code => {
    setShowLoader(code);
    let cartType = '';
    // for showing relative skeletons
    if (getCookie('COMP_MAP')) {
      const COMP_MAP = JSON.parse(getCookie('COMP_MAP'));
      COMP_MAP.COSelected = false;
      setCookie('ION', 'COMP_MAP', JSON.stringify(COMP_MAP));
    }

    if (changeOffer) cartType = 'CHANGE_OFFER';
    try {
      if (rootState.cart?.offers.length > 0) {
        const offerId = await rootState.cart?.offers?.filter(
          offer => offer.baseOffer?.serviceGroup === 'DUALPLAY'
        )[0]?.id;
        const data = await removeTariff(graphql, offerId, cartType);
        if (data != null && !data.error) {
          if (getCookie('cart_Type') === 'CHANGE_OFFER') {
            // setShowCrossSell(true);
            setHideCS(false);
          }
          removeFromCartAnalytics(data);
          dispatch({ type: 'SET_CART', payload: data });
          displayCart({
            showCart: false,
            dispatch,
            localStorage: localStore,
            graphql,
            cart: data,
            disablenNextButton: true,
            showNextButton: false,
          });
          setOfferSelected(null);
          setShowTv(false);
          setShowAddon(false);
          setShowNext(false);
          setShowLoader(' ');
          setErrorModalOccurence(0);
          errorBBModal.disable();
          setOnLoadError(false);
        } else {
          setOnLoadError(false);
          if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
          if (!getCookie('token-missing') && !getCookie('found-403'))
            setErrorModalOccurence(errorModalOccurence + 1);
          if (!getCookie('found-403')) errorBBModal.enable();
          if (!getCookie('token-missing')) errorBBModal.enable();
          if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
          setShowLoader(' ');
        }
      }
    } catch (err) {
      if (getCookie('cart_Type') === 'CHANGE_OFFER') {
        // setShowCrossSell(true);
        setHideCS(true);
      }
      setOnLoadError(false);
      if (!getCookie('token-missing') && !getCookie('found-403')) setOpenError(true);
      if (!getCookie('token-missing') && !getCookie('found-403'))
        setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorBBModal.enable();
      if (!getCookie('token-missing')) errorBBModal.enable();
      if (!getCookie('token-missing') && !getCookie('found-403')) openAPIFailureModal.enable();
      setShowLoader(' ');
    }
  };

  const useMaxHeight = useMaxHeightCard();

  const handleLeftClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current?.swiper?.slidePrev();
  }, []);

  const handleRightClick = useCallback(() => {
    if (!swiperRef.current) return;
    swiperRef.current?.swiper?.slideNext();
  }, []);

  const checkArrowsStatus = () => {
    if (swiperRef.current?.swiper?.isBeginning) {
      setLeftArrowDisabled(true);
      // setRightArrowDisabled(false);
    }
    if (swiperRef.current?.swiper?.isEnd) {
      // setLeftArrowDisabled(false);
      setRightArrowDisabled(true);
    }
    // if (swiperRef.current?.swiper?.isBeginning && swiperRef.current?.swiper?.isEnd) {
    //   setLeftArrowDisabled(true);
    //   setRightArrowDisabled(true);
    // }
    if (!swiperRef.current?.swiper?.isBeginning) {
      setLeftArrowDisabled(false);
      // setRightArrowDisabled(false);
    }
    if (!swiperRef.current?.swiper?.isEnd) {
      // setLeftArrowDisabled(false);
      setRightArrowDisabled(false);
    }
  };
  const handleKeydown = e => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault();
      e.target.click();
    }
  };

  const updatePaginationDots = swiper => {
    const paginationDots = swiper.el?.querySelectorAll('.swiper-pagination-bullet');
    if (!paginationDots || !paginationDots.length) return;

    const activeIndex = swiper.realIndex ?? swiper.activeIndex ?? 0;

    paginationDots.forEach((dot, i) => {
      dot.setAttribute('role', 'button');
      dot.setAttribute('tabindex', '0');

      dot.removeEventListener('keydown', handleKeydown);
      dot.addEventListener('keydown', handleKeydown);

      if (i === activeIndex) {
        dot.setAttribute('aria-label', 'Current plan');
      } else if (i < activeIndex) {
        dot.setAttribute('aria-label', 'Previous plan');
      } else {
        dot.setAttribute('aria-label', 'Next plan');
      }
    });
  };

  useEffect(() => {
    checkArrowsStatus();
    if (broadbandData?.length > 0 && !isNBIJourney) {
      setLoading(false);
    }
  }, [broadbandData]);
  useEffect(() => {
    if (!hold) broadbandOnload();
  }, [isPrequaled, hold]);

  return (
    <Container
      id={id}
      sx={{
        p: 0,
        mb: 2,
        mt: { xs: 4, md: 8 },
        display: { sm: 'flex', lg: 'flex' },
        flexDirection: { sm: 'column', lg: 'column' },
        alignItems: { sm: 'center', lg: 'center' },
        justifyContent: { sm: 'center', lg: 'center' },
      }}
      maxWidth={broadbandData?.length === 1 ? 'md' : 'lg'}
    >
      {hasContent && (
        <Box>
          <EirInformation
            title={broadband.title}
            description={broadband.description}
            useH1={cmsData?.attributes?.EirInformation_Broadband_Title?.useH1}
            style={{ title: styles(theme).title }}
          />
        </Box>
      )}

      {hideOfferCard ? (
        ''
      ) : (
        <Box sx={styles(theme).offerCards} id='offerCardData'>
          {!md && broadbandData?.length > 3 && eligibleForCO === true && (
            <IconButton
              size='small'
              sx={styles(theme).prevArrow}
              onClick={handleLeftClick}
              disabled={leftArrowDisabled}
              disableRipple
              disableTouchRipple
            >
              <KeyboardArrowLeftIcon />
            </IconButton>
          )}
          {loading && getCookie('MYEIR_BB_ADDED') !== 'true' && (
            <Stack spacing={3} direction='row' sx={{ justifyContent: 'center' }}>
              {Array(xs ? 1 : 3)
                .fill()
                .map((_, index) => (
                  <EirOfferCard loading index={index} isBroadband />
                ))}
            </Stack>
          )}
          {((lg && broadbandData?.length !== 1) || md) && (
            <SwiperCarousel
              settings={{
                className: 'content-carousel-broadband',
                pagination: { enable: true, clickable: true },
                modules: [Pagination],
                initialSlide: 0,
                updateOnWindowResize: true,
                slidesPerView: 'auto',
                slidesPerGroup: broadbandData?.length > 5 && !md ? 3 : 1,
                onSlideChange: swiper => {
                  checkArrowsStatus();
                  updatePaginationDots(swiper);
                },
                breakpoints: {
                  320: {
                    slidesPerView: 1,
                  },
                  600: {
                    slidesPerView: 2,
                  },
                  1200: {
                    slidesPerView: 3,
                  },
                },
                onAfterInit: swiper => {
                  setTimeout(() => {
                    updatePaginationDots(swiper);
                  }, 100);
                },
                onPaginationUpdate: swiper => {
                  updatePaginationDots(swiper);
                },
                onBreakpoint: swiper => {
                  updatePaginationDots(swiper);
                },
              }}
              sliderRef={swiperRef}
              style={{
                ...style.offerSlider?.swiper,
                ...(broadbandData?.length < 3 && style.offerSlider.centerSwiper),
              }}
            >
              {!loading &&
                broadbandData &&
                broadbandData.length > 0 &&
                eligibleForCO === true &&
                broadbandData.map(
                  (offer, i) =>
                    ((broadbandData?.length > 0 && xs) || broadbandData.length > 1) && (
                      <SwiperSlide key={i}>
                        <EirOfferCard
                          headerImgDescription={offer.headerImgDescription}
                          slideNumber={i}
                          topTag={offer.topTag}
                          preTitle={offer.preTitle}
                          title={offer.title}
                          // headerImage={['test-broadband.svg']}
                          headerImage={offer.image}
                          headerImageActive={offer.imageActive ? offer.imageActive : ['']}
                          priceIncreaseTagline={offer.priceIncreaseTagline}
                          sash={offer.sash}
                          contractLength={offer.contractLength}
                          afterPrice={offer.afterPrice}
                          afterPricePosition={offer.afterPricePosition[0]}
                          price={offer.price}
                          noDiscount={offer.noDiscount}
                          description={offer.description}
                          descriptions={offer.descriptions}
                          offerCardButtonDisable={offerCardButtonDisable}
                          selectButton={
                            staticbbCard
                              ? undefined
                              : {
                                  title: 'Select Offer',
                                  action: () =>
                                    offer.code === offerSelected
                                      ? removeTariffs(offer.code)
                                      : selectTariff(
                                          offer.code,
                                          offer.offerCode,
                                          offer.discountDuration,
                                          offer
                                        ),
                                }
                          }
                          offerSelected={offer.code === offerSelected}
                          promotion={offer.promotion}
                          moreInfo={offer.moreInfo}
                          useMaxHeight={useMaxHeight}
                          color='primary'
                          code={offer.code}
                          showLoader={showLoader}
                          isBroadband
                          cmsData={cmsData}
                        />
                      </SwiperSlide>
                    )
                )}
            </SwiperCarousel>
          )}
          {!loading &&
            broadbandData &&
            broadbandData.length > 0 &&
            broadbandData.length === 1 &&
            !xs &&
            eligibleForCO === true &&
            broadbandData.map((offer, i) => (
              <Grid key={i} item xs={12}>
                <EirSingleOfferCard
                  topTag={offer.topTag}
                  preTitle={offer.preTitle}
                  title={offer.title}
                  headerImage={offer.image}
                  headerImageActive={offer.imageActive ? offer.imageActive : ['']}
                  singleTariffHeaderImage={offer.singleTariffImage}
                  singleHeaderImgDescription={offer.singleHeaderImgDescription}
                  priceIncreaseTagline={offer.priceIncreaseTagline}
                  offerSelected={offer.code === offerSelected}
                  moreInfo={offer.moreInfo}
                  code={offer.code}
                  sash={offer.sash}
                  description={offer.description}
                  descriptions={offer.descriptions}
                  price={offer.price}
                  contractLength={offer.contractLength}
                  afterPrice={offer.afterPrice}
                  noDiscount={offer.noDiscount}
                  index={i}
                  selectButton={
                    staticbbCard
                      ? undefined
                      : {
                          title: 'Select offer',
                          action: () =>
                            offer.code === offerSelected
                              ? removeTariffs(offer.code)
                              : selectTariff(
                                  offer.code,
                                  offer.offerCode,
                                  offer.discountDuration,
                                  offer
                                ),
                        }
                  }
                  color='primary'
                  showLoader={showLoader}
                  isBroadband
                  offerCardButtonDisable={offerCardButtonDisable}
                  cmsData={cmsData}
                />
              </Grid>
            ))}

          {!md && broadbandData?.length > 3 && eligibleForCO === true && (
            <IconButton
              size='small'
              sx={styles(theme).nextArrow}
              onClick={handleRightClick}
              disabled={RightArrowDisabled}
              disableRipple
              disableTouchRipple
            >
              <KeyboardArrowRightIcon />
            </IconButton>
          )}
        </Box>
      )}

      {offerCardTextVisible && (
        <Box sx={styles(theme).offerCardsText}>
          <Typography>If you wish to get a second broadband for a different home,&nbsp;</Typography>
          <Typography sx={styles(theme).offerCardsTextLink}>please Change address.</Typography>
        </Box>
      )}
      {openError && errorModalOccurence > errorModalMaxOccurence && (
        <ApiFailureModal openAPIFailureModal={openAPIFailureModal} handleOk={handleOk} />
      )}
      {showModal.value && <LoginMain403 />}
      {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
        <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
      )}
      {errorBBModal.value && !showSessionExpiredModal.value && !showModal.value && (
        <ErrorModal
          errorBBModal={errorBBModal}
          occurences={errorModalMaxOccurence}
          currentOccurence={errorModalOccurence}
          ctaMethod={onLoadError ? broadbandOnload : () => {}}
        />
      )}
    </Container>
  );
};

export default BroadbandOfferCardContainer;
